export default "__VITE_PUBLIC_ASSET__b06e2366__"